import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import useApi from "../../../../../utils/api";
import {
	getToastErrorMessage,
	isCancelError,
} from "../../../../../utils/helpers/errors";
import { formatDateRange } from "../../../../../utils/helpers/api";

export const useUserOverview = (id) => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);

	const { authGet } = useApi();

	const fetch = useCallback(
		async ({ params, ...config }) => {
			const { from, to } = params || {};
			if (!from || !to) {
				return;
			}

			setLoading(true);
			try {
				const response = await authGet(
					`/time-sheet/weekly-summary/${id}`,
					{
						...config,
						params: formatDateRange(from, to),
					},
				);
				setData(response);
			} catch (err) {
				if (!isCancelError(err)) {
					toast.error(getToastErrorMessage(err));
				}
			} finally {
				setLoading(false);
			}
		},
		[id, authGet],
	);

	return { data, fetch, loading };
};
